webpackJsonp([6],{

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__ = __webpack_require__(19);


__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].checkWihlistTagId();
  __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].bindWishListEvent();
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-form').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-form').submit(function (e) {
      e.preventDefault();
      var brand = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('brand');
      var emailField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-address');
      var email = emailField.val();
      if (!email || __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(email).length == 0) {
        emailField.closest('.field').addClass('is-error');
      } else if (validateEmailField(email)) {
        saveBrandInquiryEmail(brand, email);
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-address').keyup(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.field').removeClass('is-error');
    });
  }
});
function saveBrandInquiryEmail(brand, email) {
  var dataObject = {
    brand: brand,
    email: email
  };
  var url = window.rcProps ? window.rcProps.brandEmailSaveHref : "";
  var confirmNotificationUrl = window.rcProps ? window.rcProps.brandEmailConfirmNotificationHref : "";
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(url, dataObject, function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-address').val("");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: confirmNotificationUrl,
      type: 'notification',
      triggerOpen: true
    });
  });
}
function validateEmailField(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

/***/ })

},[195]);


// WEBPACK FOOTER //
// dist/lp.js